module.exports = __webpack_public_path__ + "static/media/champagne.27718a44.svg";